import React from 'react';
import { createEmptyForm } from './types';
import { TEMPLATES } from './templates';
import type { QuickSetupFormState, SearchCategory } from './types';

export default function TemplateSelector({
  category,
  form,
  onApply,
}: {
  category: SearchCategory;
  form: QuickSetupFormState;
  onApply: (patch: Partial<QuickSetupFormState>) => void;
}) {
  const templates = TEMPLATES[category];
  if (!templates.length) return null;

  return (
    <div className="template-selector">
      <span className="template-selector-label">Start from template</span>
      <div className="template-selector-chips">
        {templates.map((t) => (
          <button
            key={t.id}
            type="button"
            className="template-chip"
            onClick={() =>
              onApply({
                ...createEmptyForm(category),
                source_names: form.source_names,
                telegram_chat_id: form.telegram_chat_id,
                run_scrape: form.run_scrape,
                ...t.patch,
                name: t.name,
              })
            }
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}
